import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTournament } from "../context/TournamentContext";
import { useLanguage } from "../context/LanguageContext";
import { Loader2, Trophy } from "lucide-react";

export default function SharePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadTournament } = useTournament();
  const { t } = useLanguage();
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadAndRedirect = async () => {
      try {
        const tournament = await loadTournament(id);
        if (tournament) {
          // Redirect to the appropriate page based on format
          if (tournament.format === "league") {
            navigate(`/league/${id}`, { replace: true });
          } else {
            navigate(`/bracket/${id}`, { replace: true });
          }
        } else {
          setError("Tournament not found");
        }
      } catch (err) {
        setError("Tournament not found or link is invalid");
      }
    };

    if (id) {
      loadAndRedirect();
    }
  }, [id, loadTournament, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-center">
          <Trophy className="w-16 h-16 text-white/20 mx-auto mb-4" />
          <h1 className="font-heading text-2xl text-white mb-2">{t('toast.tournamentNotFound')}</h1>
          <p className="text-white/60 mb-6">{error}</p>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-2 bg-neon-cyan text-black font-heading uppercase rounded hover:bg-neon-cyan/80 transition-colors"
          >
            {t('champion.newTournament')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-neon-cyan animate-spin mx-auto mb-4" />
        <p className="text-white/60 font-heading uppercase tracking-wide">{t('loading')}</p>
      </div>
    </div>
  );
}
